import {useSelector} from "react-redux";
import {Alert} from "antd";
import dayjs from "dayjs";
import {trainingLockSelector} from "~/features/Auth/authSlice";

function TrainingLockBanner() {

	const trainingLock = useSelector(trainingLockSelector);

	if (!trainingLock?.locked) return null;

	const sessions = trainingLock.sessions || [];

	const formatTime = (start, end) => {
		const s = start ? dayjs.unix(start) : null;
		const e = end   ? dayjs.unix(end)   : null;
		if (!s) return '';
		const day  = s.format('DD/MM/YYYY');
		const from = s.format('HH:mm');
		const to   = e ? e.format('HH:mm') : '';
		return `${day} ${from}${to ? ' - ' + to : ''}`;
	};

	return (
		<Alert
			type="error"
			banner
			showIcon
			style={{margin: '0 0 12px', fontWeight: 500}}
			message="Tài khoản của bạn đang bị tạm khóa"
			description={
				<div>
					<p style={{marginBottom: 6}}>
						Bạn có {sessions.length} buổi đào tạo đã quá giờ nhưng chưa cập nhật kết quả.
						Vui lòng vào mục <b>Lịch đào tạo</b> để cập nhật (Đã đào tạo / Chưa đào tạo / Dời lịch / Hủy)
						thì tài khoản mới được mở khóa.
					</p>
					{sessions.length > 0 && (
						<ul style={{margin: 0, paddingLeft: 18}}>
							{sessions.map((s) => (
								<li key={s.id}>
									<b>{s.topic}</b> — {formatTime(s.startTime, s.endTime)}
								</li>
							))}
						</ul>
					)}
				</div>
			}
		/>
	);
}

export default TrainingLockBanner;
